// Placeholders for tickets whose subject matter, requester or client record no longer exists.
export const SUBJECT_MATTER_PLACEHOLDER = 'Not Defined';
export const REQUESTER_PLACEHOLDER = 'Unknown requester';
export const CLIENT_PLACEHOLDER = 'Unknown client';

/** Subject matter name for a ticket row, or "Not Defined" when the record is missing. */
export function subjectMatterLabel(ticket: any): string {
  const value = ticket && ticket.subjects ? ticket.subjects.Value : null;
  return value ? value : SUBJECT_MATTER_PLACEHOLDER;
}

/** Requester's client name for a ticket row, or "Unknown client" when the requester or client is missing. */
export function clientLabel(ticket: any): string {
  const name = ticket && ticket.user && ticket.user.client ? ticket.user.client.ClientName : null;
  return name ? name : CLIENT_PLACEHOLDER;
}

/** Requester name as the list has always shown it ("-" for a blank first name), or "Unknown requester" when missing. */
export function requesterLabel(ticket: any): string {
  const user = ticket ? ticket.user : null;
  if (!user) {
    return REQUESTER_PLACEHOLDER;
  }
  return ((user.FirstName ? user.FirstName : '-') + ' ' + (user.LastName || '')).trim();
}
